export default __webpack_public_path__ + "static/media/arrow_top.9972757f.svg";